enum EHookKeys {
    APOLLO_ERROR = 'apollo:error',
}

export default EHookKeys
